import {
  dynamicCollectionRendererKey,
  dynamicElementsButtonKey,
  dynamicElementsSimpleTextKey,
} from '@epicuro-next/constants/dynamic-elements';
import { OPENED_LIST_ENTITY_PROVIDER_KEY } from '@epicuro-next/data-providers/providers-registry';
import {
  IDynamicItem,
  LogicOperator,
  Operation,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import {
  isListAllowedForEdit,
  isListDetailTab,
  isPowerList,
} from '../if-statements/if-statements';

// tslint:disable:no-duplicate-string

const isPreviewEnabled: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_ENTITY_PROVIDER_KEY,
      property: 'powerListPreviewMode',
    },
    true,
  ],
];

const isNotPreviewEnabled: Operation = [
  LogicOperator.EQ,
  [
    {
      provider: OPENED_LIST_ENTITY_PROVIDER_KEY,
      property: 'powerListPreviewMode',
    },
    false,
  ],
];

export const previewListButtonItem: IDynamicItem = {
  contentTypeId: dynamicCollectionRendererKey,
  styles: {
    classes: ['p-2', 'p-md-0', 'd-sm-sticky-bottom'],
  },
  if: [
    LogicOperator.AND,
    [isListAllowedForEdit, isPowerList, isListDetailTab],
  ] as unknown as Operation,
  inputs: {
    items: [
      {
        contentTypeId: dynamicElementsButtonKey,
        inputs: {
          action: 'toggle-preview-mode',
        },
        styles: {
          classes: [
            'btn-secondary',
            'ml-md-2',
            'd-inline-flex',
            'flex-grow-1',
            'align-items-center',
            'justify-content-center',
          ],
          style: {
            'min-width': '8rem',
          },
        },
        children: [
          {
            contentTypeId: dynamicElementsSimpleTextKey,
            inputs: {
              text: '@@powerListExitPreviewButton',
            },
            if: isPreviewEnabled,
          },
          {
            contentTypeId: dynamicElementsSimpleTextKey,
            inputs: {
              text: '@@powerListPreviewButton',
            },
            if: isNotPreviewEnabled,
          },
        ],
      },
    ],
  },
};
